import { useCallback } from "react"
import { Button, Flex, Text } from "@chakra-ui/react"
import { CHAIN_ID } from "@mezo/sdk"

import {
  selectDepositActionDepositId,
  selectDepositActionId,
  selectDepositActionNewLockDuration,
  selectDepositActionStatus,
  selectDepositActionToken,
  selectDepositActionType,
  selectIsOnEthereumChain,
  setActionStatus,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import TransactionProgressLoader from "#/shared/components/TransactionProgressLoader"
import { SDK_NETWORK } from "#/shared/constants"
import { useDepositActions } from "#/shared/hooks"

import SwitchChainButton from "../Buttons/SwitchChainButton"

export default function BoostModalButton() {
  const token = useDappSelector(selectDepositActionToken)
  const id = useDappSelector(selectDepositActionId)
  const depositId = useDappSelector(selectDepositActionDepositId)
  const lockupTime = useDappSelector(selectDepositActionNewLockDuration)
  const lockType = useDappSelector(selectDepositActionType)
  const lockStatus = useDappSelector(selectDepositActionStatus)
  const hasCorrectChain = useDappSelector(selectIsOnEthereumChain)

  const dispatch = useDappDispatch()

  const { lock, isProcessing } = useDepositActions(
    id,
    depositId,
    token,
    lockupTime,
  )

  const boostButtonHandler = useCallback(async () => {
    const depositLocked = await lock()

    if (depositLocked) {
      dispatch(setActionStatus("completed"))
    }
  }, [lock, dispatch])

  const buttonText = lockType === "extend" ? "Extend boost" : "Resume boost"

  if (!hasCorrectChain)
    return (
      <SwitchChainButton
        label={lockType}
        chainId={CHAIN_ID[SDK_NETWORK]}
        variant="primary"
        size="large"
      />
    )

  return (
    <Flex alignItems="center" gap="16px">
      <Button
        variant={isProcessing ? "disabled" : "primary"}
        size="large"
        onClick={boostButtonHandler}
        isDisabled={isProcessing}
      >
        {isProcessing ? (
          <TransactionProgressLoader text="Extending boost" />
        ) : (
          buttonText
        )}
      </Button>
      {lockStatus === "error" && (
        <Text textAlign="right" variant="body" color="primary.red.100">
          Boost failed, try again
        </Text>
      )}
    </Flex>
  )
}
